export const GET_ACTIONS = {
    REQUEST: 'NOTICE_STAGE.GET_ACTIONS.REQUEST',
    SUCCESS: 'NOTICE_STAGE.GET_ACTIONS.SUCCESS',
    FAILED: 'NOTICE_STAGE.GET_ACTIONS.FAILED',
};
